import {
  ActivityIndicator,
  Dimensions,
  Modal,
  PixelRatio,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import Colours from "../../utils/Colours";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import PaymentReceipt from "./PaymentReceipt";
import Toast from "react-native-toast-message";
import toastConfig from "../../toasts/toastConfig";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import socketConfig from "../../utils/socketConfig";
import useAuth from "../../hooks/useAuth";
import TransactionDigitCodeScreen from "../transactionDigitCode/TransactionDigitCodeScreen";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import NoticeAlertComp from "../../alertComp/NoticeAlertComp";
import AsyncStorage from "@react-native-async-storage/async-storage";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const MAX_ATTEMPTS = 15;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const ConfirmTransfer = ({
  transferRecipientDetails,
  tableToUseID,
  billingAddress,
  transfer_source,
  selectedBankCode,
  showPaymentReceipt,
  setShowPaymentReceipt,
  hideAllPayScreens,
}) => {
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isLoading4, setIsLoading4] = useState(false);
  const [reference, setReference] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [transferDate, setTransferDate] = useState();
  const [transactionCharge, setTransactionCharges] = useState("");
  const [transactCodeCorrect, setTransactCodeCorrect] = useState(false);
  const [showTransactionDigitCodeScreen, setShowTransactionDigitCodeScreen] = useState(false);
  const [isNoticeAlertVisible, setIsNoticeAlertVisible] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [noticeMessage, setNoticeMessage] = useState("");
  const [startPolling, setStartPolling] = useState(false);
  const [isConnected, setIsConnected] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  // const [showPaymentReceipt2, setShowPaymentReceipt2] = useState(false)

  const axiosPrivate = useAxiosPrivate();

  const { sub } = useAuth();

  // useEffect(() => {
  //     const socket = new WebSocket(socketConfig.WEBSOCKET_URL)
  //     const userID = sub;

  //     socket.onopen = () => {
  //         //console.log('WebSocket connected');
  //         setIsConnected(true);
  //         socket.send(JSON.stringify({ type: 'identify', userID }));
  //     };

  //     socket.onmessage = (event) => {
  //         const message = JSON.parse(event.data);
  //         //console.log('Message from server:', message);

  //         if (message.status === "failed") {
  //             setIsLoading4(false);
  //             setIsErrorCompVisible(true);
  //             setErrorMessage('Transaction Failed');
  //             return;
  //         }

  //         if (message.transferReference === transferRecipientDetails.transferReference) {
  //             setIsLoading4(false);
  //             setReference(message.transferReference);
  //             setTransferDate(message.dateAndTime);
  //             setShowPaymentReceipt(true);
  //         } else {
  //             setIsLoading4(false);
  //             setIsErrorCompVisible(true);
  //             setErrorMessage('Transaction Error');
  //         }
  //     };

  //     socket.onclose = () => {
  //         //console.log('WebSocket disconnected');
  //         setIsConnected(false);
  //     };

  //     socket.onerror = (error) => {
  //         //console.error('WebSocket error:', error);
  //         setIsErrorCompVisible(true);
  //         setErrorMessage('Transaction Error');
  //     };

  //     return () => {
  //         socket.close();
  //     };
  // }, [sub]);

  useEffect(() => {
    const fetchCharges = async () => {
      try {
        const res = await axiosPrivate.get("/getAllCharges/getAllCharges");
        if (res.data && res.data.length > 0) {
          setTransactionCharges(res.data[0]);
        }
      } catch (err) {
        //console.error('Error fetching charges:', err);
      }
    };
    fetchCharges();
  }, []);

  useEffect(() => {
    //console.log('transactCodeCorrect', transactCodeCorrect)
    if (transactCodeCorrect) {
      initiateTransfer();
    }
  }, [transactCodeCorrect]);

  const initiateTransferIf = async () => {
    //setIsLoading4(true);
    //console.log("We are here now");
    const seen = await AsyncStorage.getItem("hasSeenTransferNameNotice");
    if (seen === "false" || seen === null) {
      // console.log("seen", seen);
      setNoticeMessage(
        "Note: In some cases, your transfers will display 'PAYSTACK' (our payment service partner) as the sender name, not your full name."
      );
      setIsNoticeAlertVisible(true);
    } else {
      // console.log("Also Here now");
      setShowTransactionDigitCodeScreen(true);
    }

    // if (transactCodeCorrect) {
    //     initiateTransfer()
    // }
  };

  useEffect(() => {
    let pollingInterval;
    let attempts = 0;
    const reference = transferRecipientDetails.transferReference;

    const checkTransactionStatus = async () => {
      try {
        //console.log(`POLLING: Attempt ${attempts + 1} of ${MAX_ATTEMPTS}...`);

        const response = await axiosPrivate.get(
          `/verifyTransferTransact/verifyTransferTransact/${reference}`
        );

        //console.log("POLLING RESP:", response.data);

        const { success, data } = response.data;

        if (!success) {
          // Backend says verification failed (e.g. bad reference)
          clearInterval(pollingInterval);
          setIsLoading4(false);
          setStartPolling(false);
          setErrorMessage("Unable to verify transfer. Please try again later.");
          setIsErrorCompVisible(true);
          return;
        }

        if (data?.status === "success") {
          // ✅ Transfer verified successfully
          clearInterval(pollingInterval);
          setIsLoading4(false);
          setStartPolling(false);
          setReference(data.reference);
          setTransferDate(data.dateAndTime);
          setShowPaymentReceipt(true);
          // setSuccessMessage("Transfered successfully!");
          //  setIsSuccessCompVisible(true);
        } else if (data?.status === "failed") {
          // ❌ Transfer failed
          clearInterval(pollingInterval);
          setIsLoading4(false);
          setStartPolling(false);
          setErrorMessage("Transfer failed. Please try again.");
          setIsErrorCompVisible(true);
        } else if (data?.status === "pending") {
          // ⏳ Still pending — keep polling
          //console.log("Transfer still pending...");
          attempts++;
          if (attempts >= MAX_ATTEMPTS) {
            //console.warn("POLLING: Max attempts reached. Stopping polling.");
            clearInterval(pollingInterval);
            setStartPolling(false);
            setIsLoading4(false);
            setErrorMessage(
              "Transfer verification is taking longer than expected. Please check back later."
            );
            setIsErrorCompVisible(true);
          }
        }
      } catch (error) {
        //console.error("Error fetching verification status:", error);
        clearInterval(pollingInterval);
        setIsLoading4(false);
        setStartPolling(false);
        setErrorMessage("Transaction error occured, try again later.");
        setIsErrorCompVisible(true);
      }
    };

    if (startPolling) {
      pollingInterval = setInterval(checkTransactionStatus, 5000); // poll every 5s
    }

    return () => clearInterval(pollingInterval);
  }, [startPolling]);

  const initiateTransfer = async () => {
    const tableID = tableToUseID;

    setStartPolling(true);

    setIsLoading4(true);
    setIsButtonClicked(true);

    try {
      const response = await axiosPrivate.post("/transfer/initiate", {
        tableID,
        transfer_source,
        billingAddress,
        selectedBankCode,
        amount: transferRecipientDetails.amount,
        reason: transferRecipientDetails.reason, //Change reason to user firstname
        recipient_code: transferRecipientDetails.recipient_code,
        transferReference: transferRecipientDetails.transferReference,
        account_number: transferRecipientDetails.account_number,
        account_name: transferRecipientDetails.account_name,
        bank_name: transferRecipientDetails.bank_name,
      });
      //console.log('response', response.data.data)
      //console.log('response34', response.data)
      setTransactCodeCorrect(false);
    } catch (error) {
      if (error.response) {
        // console.error(
        //   "Server Error:",
        //   error.response.status,
        //   error.response.data,
        //   error.response.data.error
        // );
        setErrorMessage(
          error.response.data.error || "An Error occured while processing this transaction"
        );
        setIsErrorCompVisible(true);
      } else if (error.request) {
        //  //console.error('Network Error:', error.request);
        setErrorMessage("Network error please check your internet connection");
        setIsErrorCompVisible(true);
      } else {
        // //console.error('Error:', error.message);
        setErrorMessage("An Error occured while processing this transaction");
        setIsErrorCompVisible(true);
      }
    } finally {
      // setIsLoading4(false)
      setTransactCodeCorrect(false);
    }
  };

  const amount = Number(transferRecipientDetails?.amount || 0);
  let serviceCharge = 0;
  let vat = 0;

  if (amount > transactionCharge.threshold1) {
    serviceCharge = transactionCharge.Charges1.price;
    vat = transactionCharge.Charges1.tax;
    //console.log('service Charge', serviceCharge)
    //console.log('vat', vat)
  } else if (amount > transactionCharge.threshold4 && amount <= transactionCharge.threshold1) {
    serviceCharge = transactionCharge.Charges2.price;
    vat = transactionCharge.Charges2.tax;
    //console.log('service Charge', serviceCharge)
    //console.log('vat', vat)
  } else if (amount <= transactionCharge.threshold4) {
    serviceCharge = transactionCharge.Charges3.price;
    vat = transactionCharge.Charges4.tax;
    //console.log('service Charge', serviceCharge)
    //console.log('vat', vat)
  }

  const isCalculatingCharges = amount > 0 && serviceCharge === 0 && vat === 0;

  if (isLoading4) {
    return (
      <View style={styles.loaderContainer}>
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }

  return (
    <View>
      <View style={styles.confirmPayContainer}>
        <Text style={styles.titleTxt}>Beneficiary name</Text>
        <View style={styles.beneficiaryDetail}>
          <Text style={styles.subTxt}>{transferRecipientDetails?.account_name}</Text>
        </View>

        <Text style={styles.titleTxt}>Beneficiary Account No.</Text>
        <View style={styles.beneficiaryDetail}>
          <Text style={styles.subTxt}>{transferRecipientDetails?.account_number}</Text>
        </View>

        <Text style={styles.titleTxt}>Beneficiary Bank</Text>
        <View style={styles.beneficiaryDetail}>
          <Text style={styles.subTxt}>{transferRecipientDetails?.bank_name}</Text>
        </View>

        <Text style={styles.titleTxt}>Transfer Amount</Text>
        <View style={styles.beneficiaryDetail}>
          <Text style={styles.subTxt}>NGN {amount.toLocaleString()}</Text>
        </View>

        <Text style={styles.titleTxt}>Service Charge + VAT</Text>
        <View style={styles.beneficiaryDetail}>
          <Text style={styles.subTxt}>NGN {(serviceCharge + vat).toFixed(2)}</Text>
        </View>

        {/* <Text style={styles.titleTotal}>Total</Text>
                <View style={styles.totalDetail}>
                    <Text style={styles.subTxt}>
                        NGN {(amount + serviceCharge + vat).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Text>
                </View> */}
      </View>

      <TouchableOpacity
        style={[
          styles.buttonGray,
          {
            backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY,
          },
        ]}
        onPress={initiateTransferIf}
        //   onPress={() => setShowPaymentReceipt2(true)}
        disabled={isLoading4 || isCalculatingCharges}
      >
        {isLoading4 ? (
          <ActivityIndicator size="small" color="white" />
        ) : (
          <Text
            style={{
              color: isButtonClicked ? "white" : Colours.DARKGRAY,
              fontSize: 17,
              fontFamily: "Sen-Bold",
            }}
          >
            Confirm
          </Text>
        )}
      </TouchableOpacity>

      <Modal
        animationType="fade"
        visible={showTransactionDigitCodeScreen}
        onRequestClose={() => setShowTransactionDigitCodeScreen(false)}
      >
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <TransactionDigitCodeScreen
            hideScreen={() => setShowTransactionDigitCodeScreen(false)}
            setTransactCodeCorrect={() => setTransactCodeCorrect(true)}
            doingsAmount={transferRecipientDetails.amount}
          />
        </View>
      </Modal>

      <Modal
        AnimationType="fade"
        // visible={showPaymentReceipt2}
        visible={showPaymentReceipt}
      >
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          {/* <View style={styles.componentStyle}> */}

          <PaymentReceipt
            hideAllPayScreens={hideAllPayScreens}
            transferRecipientDetails={transferRecipientDetails}
            reference={reference}
            transferDate={transferDate}
          />

          {/* </View> */}
        </ScrollView>
      </Modal>
      {/* 
            <Modal
                visible={isSuccessCompVisible}
                transparent={true}
                animationType="fade"
            >
                <SuccessAlertComp
                    message={successMessage}
                    onClose={() => {
                        setIsSuccessCompVisible(false)
                    }}
                />
            </Modal> */}

      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>

      <Modal
        visible={isNoticeAlertVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsNoticeAlertVisible(false)}
      >
        <NoticeAlertComp
          message={noticeMessage}
          onClose={() => {
            setIsNoticeAlertVisible(false);
            setShowTransactionDigitCodeScreen(true);
          }}
          onCancel={async () => {
            await AsyncStorage.setItem("hasSeenTransferNameNotice", "true");
            setIsNoticeAlertVisible(false);
            setShowTransactionDigitCodeScreen(true);
          }}
          fromTransfer={true}
        />
      </Modal>

      <Toast config={toastConfig} />
    </View>
  );
};

export default ConfirmTransfer;

const styles = StyleSheet.create({
  loaderContainer: {
    flex: 1,
    marginTop: dynamicSpacing(10),
    backgroundColor: "#fff", // optional
  },
  confirmPayContainer: {
    display: "flex",
    padding: dynamicSpacing(15),
    margin: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    backgroundColor: Colours.PRIMARY_LIGHTER,
  },
  titleTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  titleTotal: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  subTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  beneficiaryDetail: {
    display: "flex",
    padding: dynamicSpacing(10),
    backgroundColor: Colours.PRIMARY_LIGHT,
    borderRadius: dynamicSize(10),
    marginTop: dynamicSpacing(15),
    marginBottom: dynamicSpacing(15),
  },
  totalDetail: {
    display: "flex",
    padding: dynamicSpacing(10),
    backgroundColor: Colours.PRIMARY_LIGHTER,
    borderColor: Colours.PRIMARY,
    borderRadius: dynamicSize(10),
    borderWidth: dynamicSize(1),
    marginTop: dynamicSpacing(15),
    marginBottom: dynamicSpacing(15),
  },
  buttonGray: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: "15%",
    alignItems: "center",
    height: dynamicSpacing(55),
    margin: dynamicSpacing(15),
    backgroundColor: Colours.DARKGRAY,
  },
});
